import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Public pages
import Home from '@/pages/Home';
import NuevaSolicitud from '@/pages/NuevaSolicitud';
import Confirmacion from '@/pages/Confirmacion';
import ConsultarEstado from '@/pages/ConsultarEstado';
import PoliticaPrivacidad from '@/pages/PoliticaPrivacidad';

// Admin pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminSolicitudes from '@/pages/admin/AdminSolicitudes';
import AdminDetalle from '@/pages/admin/AdminDetalle';
import AdminVehiculos from '@/pages/admin/AdminVehiculos';
import AdminRutas from '@/pages/admin/AdminRutas';
import AdminRutaDetalle from '@/pages/admin/AdminRutaDetalle';
import AdminMapa from '@/pages/admin/AdminMapa';
import AdminHistorico from '@/pages/admin/AdminHistorico';
import AdminResumenDiario from '@/pages/admin/AdminResumenDiario';
import AdminFestivos from '@/pages/admin/AdminFestivos';
import AdminWhatsAppLogs from '@/pages/admin/AdminWhatsAppLogs';
import AdminChangePassword from '@/pages/admin/AdminChangePassword';
import AdminManual from '@/pages/admin/AdminManual';

// Auth guard
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/solicitud" element={<NuevaSolicitud />} />
          <Route path="/confirmacion/:ticket" element={<Confirmacion />} />
          <Route path="/consulta" element={<ConsultarEstado />} />
          <Route path="/privacidad" element={<PoliticaPrivacidad />} />
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/solicitudes" element={<ProtectedRoute><AdminSolicitudes /></ProtectedRoute>} />
          <Route path="/admin/solicitudes/:id" element={<ProtectedRoute><AdminDetalle /></ProtectedRoute>} />
          <Route path="/admin/vehiculos" element={<ProtectedRoute><AdminVehiculos /></ProtectedRoute>} />
          <Route path="/admin/rutas" element={<ProtectedRoute><AdminRutas /></ProtectedRoute>} />
          <Route path="/admin/rutas/:id" element={<ProtectedRoute><AdminRutaDetalle /></ProtectedRoute>} />
          <Route path="/admin/mapa" element={<ProtectedRoute><AdminMapa /></ProtectedRoute>} />
          <Route path="/admin/historico" element={<ProtectedRoute><AdminHistorico /></ProtectedRoute>} />
          <Route path="/admin/resumen" element={<ProtectedRoute><AdminResumenDiario /></ProtectedRoute>} />
          <Route path="/admin/festivos" element={<ProtectedRoute><AdminFestivos /></ProtectedRoute>} />
          <Route path="/admin/whatsapp" element={<ProtectedRoute><AdminWhatsAppLogs /></ProtectedRoute>} />
          <Route path="/admin/cambiar-contrasena" element={<ProtectedRoute><AdminChangePassword /></ProtectedRoute>} />
          <Route path="/admin/manual" element={<ProtectedRoute><AdminManual /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
